




















































































































import { Component, Vue } from 'vue-property-decorator'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { Loja, TipoDeTransacaoDeVenda, TipoNota, Venda } from '@/models'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import IconesDaToolbarPadroes from '@/components/layout/IconesDaToolbarPadroes.vue'
import BotaoDeDrawer from '@/components/ui/BotaoDeDrawer.vue'

@Component({
	components: {
		IconesDaToolbarPadroes,
		SeletorDeLojas,
		BotaoDeDrawer,
	},
})
export default class ToolbarDeEmissaoDeNota extends Vue  {
	mostrarConfirmacao = false
	mensagemConfirmacao = ''
	pendingCallback: (() => void) | null = null
	keyAutocompletes = 0

	get tipoOperacao(): TipoDeTransacaoDeVenda | undefined {
		return this.venda?.tipoDeTransacao
	}

	get tipoNota() {
		if (!this.venda) return 'Saída'
		return this.venda.tipoNota
	}

	handleTipoOperacaoChange(tipo: TipoDeTransacaoDeVenda) {
		if (!this.venda || !tipo) return
		if (this.venda.itens.length > 0) {
			this.mensagemConfirmacao = 'Ao alterar a operação, os itens da venda serão removidos. Deseja continuar?'
			this.pendingCallback = () => this.aplicarTipoOperacao(tipo)
			this.mostrarConfirmacao = true
			return
		}
		this.aplicarTipoOperacao(tipo)
	}

	aplicarTipoOperacao(tipo: TipoDeTransacaoDeVenda) {
		if (!this.venda) return
		const venda = { ...this.venda }
		venda.tipoDeTransacao = tipo
		this.resetarItensEConfiguracoes(venda)
		this.venda = venda
	}

	handleTipoNotaChange(tipo: TipoNota) {
		if (!this.venda || !tipo) return
		if (this.venda.itens.length > 0) {
			this.mensagemConfirmacao = 'Ao alterar o tipo de nota, os itens da venda serão removidos. Deseja continuar?'
			this.pendingCallback = () => this.aplicarTipoNota(tipo)
			this.mostrarConfirmacao = true
			return
		}
		this.aplicarTipoNota(tipo)
	}

	aplicarTipoNota(tipo: TipoNota) {
		if (!this.venda) return
		const venda = { ...this.venda }
		venda.tipoNota = tipo
		this.resetarItensEConfiguracoes(venda)
		this.venda = venda
	}

	resetarItensEConfiguracoes(venda: Venda) {
		venda.itens = []
		venda.cliente = null
		venda.cpfDoCliente = ''
		venda.exibirCpfNaNota = false
		venda.desconto = null
		venda.resumoDaVendaOrigem = null
		VendaModule.setDescontoEmSerie(null)
		VendaModule.setDigitacaoManualFiscalEmissaoNotas(false)
	}

	confirmarAlteracao() {
		if (this.pendingCallback) {
			this.pendingCallback()
		}
		this.fecharConfirmacao()
	}

	cancelarAlteracao() {
		this.keyAutocompletes++
		this.fecharConfirmacao()
	}

	fecharConfirmacao() {
		this.mostrarConfirmacao = false
		this.mensagemConfirmacao = ''
		this.pendingCallback = null
	}

	limparNota() {
		this.mensagemConfirmacao = 'Deseja limpar a nota atual? Todos os dados serão perdidos.'
		this.pendingCallback = () => {
			VendaModule.iniciarNovaNota({ identificador: '', lojaId: '' })
			this.$router.push({ name: this.$route.name as string, query: {} }).catch(() => { /* */ })
		}
		this.mostrarConfirmacao = true
	}

	get loja(): Loja | null {
		return VendaModule.lojaDaEntrada
	}

	set loja(loja: Loja | null) {
		VendaModule.setLojaDaEntrada(loja)
	}

	get venda(): Venda | null {
		return VendaModule.emissaoEntradaAtual
	}

	set venda(venda: Venda | null) {
		VendaModule.setEmissaoEntradaAtual(venda)
	}

	abrirNotaComplementar() {
		this.$router.push({ name: this.$route.name as string, query: { iniciarComplementar: 'true' } })
	}

	get itensTipoNota() {
		const itens = ['Entrada', 'Saída']

		return itens.filter(item => {
			if (
				this.tipoOperacao === 'Transferência' ||
				this.tipoOperacao === 'Consumo' ||
				this.tipoOperacao === 'Ativo' ||
				this.tipoOperacao === 'Venda' ||
				this.tipoOperacao === 'Devolução de Transferência'
			) return item === 'Saída'
			else return item
		})
	}

	get devolucaoBuscada() {
		return this.$route.query.devolucaoBuscada != null ? this.$route.query.devolucaoBuscada === 'true' : false
	}

	get digitacaoManualFiscalEmissaoNotas(): boolean {
		return VendaModule.digitacaoManualFiscalEmissaoNotas
	}

	set digitacaoManualFiscalEmissaoNotas(valor: boolean) {
		VendaModule.setDigitacaoManualFiscalEmissaoNotas(valor)
	}

	get digitacaoManualBloqueadaPorItensNaVenda(): boolean {
		return (this.venda?.itens?.length ?? 0) > 0
	}

	async iniciarNovaEntrada() {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { novaEntrada: 'true' },
			})
			.catch()
	}
}
